import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import type { WorkPackage } from '../../common/work-package';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type AddWorkPackageSuccessResponseType = WorkPackage;

async function addWorkPackage(payload: Omit<WorkPackage, 'id'>): Promise<AddWorkPackageSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.WORK_PACKAGES.INDEX}`, payload);
	return getResponse<AddWorkPackageSuccessResponseType>(response.data);
}

export function addWorkPackageOptions() {
	return mutationOptions({
		mutationFn: (payload: Omit<WorkPackage, 'id'>) => addWorkPackage(payload),
		onSuccess: async (data) => {
			console.log('Work package added successfully:', data);
			toast.success(t('finance.toast.created'));
			await queryClient.invalidateQueries({ queryKey: ['work-packages', 'list'] });
		},
		onError: (error) => toastApiError(error),
	});
}
